<div class="workflow suif-panel">
    <app-wait *ngIf="!doneLoading" class="workflow-loading"></app-wait>

    <ng-container *ngIf="doneLoading">

        <h1 class="suif-panel-title-dark">{{ this.workflowProvider.getName() }}</h1>
        <app-message-box [content]="errors"></app-message-box>

        <ng-container *ngIf="getWorkflowStep() === HELP_OPTIONS_STEP">
            <app-sign-in-help-options
                    (resetPassword)="goToResetPassword()"
                    (recoverAccountId)="goToRecoverAccountId()">
            </app-sign-in-help-options>
        </ng-container>

        <ng-container *ngIf="getWorkflowStep() === ACCOUNT_ID_RECOVERY_STEP">
            <app-lost-account-id
                    [(errors)]="errors"
                    (workflowEvent)="getEmailAddressForAccountIdRecovery($event)"
                    (previousStep)="goToHelpOptions()"
                    [submitting]="submitting">
            </app-lost-account-id>
        </ng-container>

        <ng-container *ngIf="getWorkflowStep() === ACCOUNT_ID_CONFIRMATION_STEP">
            <app-lost-account-id-confirmation
                    [emailAddress]="emailAddress"
                    [resentSuccess]="resentSuccess"
                    (resend)="resendEmail()"
                    (startOver)="goToRecoverAccountId()">
            </app-lost-account-id-confirmation>
        </ng-container>
    </ng-container>
</div>